import { create } from "zustand";

export const useContextStore = create((set, get) => ({
  // State
  contexts: [],
  loading: false,
  error: null,
  selectedContext: null,
  searchQuery: "",
  filters: {
    type: "",
    isInternal: null,
  },

  // Table features
  columnFilters: {},
  uniqueValues: {},
  paginationData: {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
    totalPages: 0,
  },

  // Modal / UI states
  isFormOpen: false,
  isEditMode: false,
  isDeleteDialogOpen: false,
  contextToDelete: null,
  isDetailDialogOpen: false,
  contextToView: null,

  // Basic Setters
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),

  setContexts: (contexts) => set({ contexts }),
  setSelectedContext: (context) => set({ selectedContext: context }),

  setSearchQuery: (searchQuery) => set({ searchQuery }),
  setFilters: (filters) => set({ filters }),
  setColumnFilters: (columnFilters) => set({ columnFilters }),
  setUniqueValues: (uniqueValues) => set({ uniqueValues }),

  setPaginationData: (data) => set((state) => ({
    paginationData: {
      ...state.paginationData,
      ...data,
      // Map from backend standard if needed
      currentPage: data.page || data.currentPage || state.paginationData.currentPage,
      itemsPerPage: data.pageSize || data.itemsPerPage || state.paginationData.itemsPerPage,
      totalItems: data.total || data.totalItems || state.paginationData.totalItems,
      totalPages: data.totalPages || state.paginationData.totalPages,
    }
  })),

  // UI Flow Actions
  openCreateForm: () => set({
    isFormOpen: true,
    isEditMode: false,
    selectedContext: null,
    error: null
  }),

  openEditForm: (context) => set({
    isFormOpen: true,
    isEditMode: true,
    selectedContext: context,
    error: null
  }),

  closeForm: () => set({
    isFormOpen: false,
    selectedContext: null,
    error: null
  }),

  openDeleteDialog: (context) => set({
    isDeleteDialogOpen: true,
    contextToDelete: context,
    error: null
  }),

  closeDeleteDialog: () => set({
    isDeleteDialogOpen: false,
    contextToDelete: null,
    error: null
  }),

  openDetailDialog: (context) => set({
    isDetailDialogOpen: true,
    contextToView: context,
    error: null
  }),

  closeDetailDialog: () => set({
    isDetailDialogOpen: false,
    contextToView: null,
    error: null
  }),
}));
